// Underground PVC Underground Drainage & Sewerage System Catalog
// HSN CODE: 39172390

export const undergroundCatalog = {
    page: 1,
    title: "ASTRAL UNDERGROUND - PVC UNDERGROUND DRAINAGE & SEWERAGE SYSTEM",
    hsn_code: "39172390",
    description: "PVC Underground drainage and sewerage pipes - IS:15328 certified",
    certification: "IS:15328",
    features: [
        "IS:15328 Certified",
        "Selfit and Ringfit systems",
        "Multiple stiffness classes (SN2, SN4, SN8)",
        "Underground drainage and sewerage"
    ],
    sections: [
        {
            name: "SELFIT PIPES - SN 2",
            fitting_type: "SELFIT",
            stiffness_class: "SN 2",
            items: [
                { size_mm: "160", length_socket: "3M S/S", product_code: "M44102031?", std_pkg: 1, price_inr_per_pc: 2301.00 },
                { size_mm: "160", length_socket: "6M S/S", product_code: "M44102061?", std_pkg: 1, price_inr_per_pc: 4596.00 },
                { size_mm: "200", length_socket: "3M S/S", product_code: "M441020314", std_pkg: 1, price_inr_per_pc: 3462.00 },
                { size_mm: "200", length_socket: "6M S/S", product_code: "M441020614", std_pkg: 1, price_inr_per_pc: 6924.00 },
                { size_mm: "250", length_socket: "3M S/S", product_code: "M441020316", std_pkg: 1, price_inr_per_pc: 5598.00 },
                { size_mm: "250", length_socket: "6M S/S", product_code: "M441020616", std_pkg: 1, price_inr_per_pc: 11196.00 },
                { size_mm: "315", length_socket: "3M S/S", product_code: "M441020318", std_pkg: 1, price_inr_per_pc: 8598.00 },
                { size_mm: "315", length_socket: "6M S/S", product_code: "M441020618", std_pkg: 1, price_inr_per_pc: 17196.00 }
            ]
        },
        {
            name: "SELFIT PIPES - SN 4",
            fitting_type: "SELFIT",
            stiffness_class: "SN 4",
            items: [
                { size_mm: "160", length_socket: "3M S/S", product_code: "M441040312", std_pkg: 1, price_inr_per_pc: 2895.00 },
                { size_mm: "160", length_socket: "6M S/S", product_code: "M441040612", std_pkg: 1, price_inr_per_pc: 5796.00 },
                { size_mm: "200", length_socket: "3M S/S", product_code: "M441040314", std_pkg: 1, price_inr_per_pc: 4332.00 },
                { size_mm: "200", length_socket: "6M S/S", product_code: "M441040614", std_pkg: 1, price_inr_per_pc: 8664.00 },
                { size_mm: "250", length_socket: "3M S/S", product_code: "M441040316", std_pkg: 1, price_inr_per_pc: 6963.00 },
                { size_mm: "250", length_socket: "6M S/S", product_code: "M441040616", std_pkg: 1, price_inr_per_pc: 13926.00 },
                { size_mm: "315", length_socket: "3M S/S", product_code: "M441040318", std_pkg: 1, price_inr_per_pc: 10560.00 },
                { size_mm: "315", length_socket: "6M S/S", product_code: "M441040618", std_pkg: 1, price_inr_per_pc: 21120.00 }
            ]
        },
        {
            name: "SELFIT PIPES - SN 8",
            fitting_type: "SELFIT",
            stiffness_class: "SN 8",
            items: [
                { size_mm: "110", length_socket: "3 MS/S", product_code: "M441080309", std_pkg: 1, price_inr_per_pc: 1554.00 },
                { size_mm: "110", length_socket: "6 MS/S", product_code: "M441080609", std_pkg: 1, price_inr_per_pc: 3114.00 },
                { size_mm: "160", length_socket: "3 MS/S", product_code: "M441080312", std_pkg: 1, price_inr_per_pc: 3315.00 },
                { size_mm: "160", length_socket: "6 MS/S", product_code: "M441080612", std_pkg: 1, price_inr_per_pc: 6624.00 },
                { size_mm: "200", length_socket: "3 MS/S", product_code: "M441080314", std_pkg: 1, price_inr_per_pc: 5223.00 },
                { size_mm: "200", length_socket: "6 MS/S", product_code: "M441080614", std_pkg: 1, price_inr_per_pc: 10446.00 },
                { size_mm: "250", length_socket: "3 MS/S", product_code: "M441080316", std_pkg: 1, price_inr_per_pc: 8106.00 },
                { size_mm: "250", length_socket: "6 MS/S", product_code: "M441080616", std_pkg: 1, price_inr_per_pc: 16212.00 },
                { size_mm: "315", length_socket: "3 MS/S", product_code: "M441080318", std_pkg: 1, price_inr_per_pc: 12972.00 },
                { size_mm: "315", length_socket: "6 MS/S", product_code: "M441080618", std_pkg: 1, price_inr_per_pc: 25944.00 }
            ]
        },
        {
            name: "RINGFIT PIPES - SN 2",
            fitting_type: "RINGFIT",
            stiffness_class: "SN 2",
            items: [
                { size_mm: "160", length_socket: "3M S/S", product_code: "M451020312", std_pkg: 1, price_inr_per_pc: 2517.00 },
                { size_mm: "160", length_socket: "6M S/S", product_code: "M451020612", std_pkg: 1, price_inr_per_pc: 4956.00 },
                { size_mm: "200", length_socket: "3M S/S", product_code: "M451020314", std_pkg: 1, price_inr_per_pc: 3735.00 },
                { size_mm: "200", length_socket: "6M S/S", product_code: "M451020614", std_pkg: 1, price_inr_per_pc: 7362.00 },
                { size_mm: "250", length_socket: "3M S/S", product_code: "M451020316", std_pkg: 1, price_inr_per_pc: 5916.00 },
                { size_mm: "250", length_socket: "6M S/S", product_code: "M451020616", std_pkg: 1, price_inr_per_pc: 11658.00 },
                { size_mm: "315", length_socket: "3M S/S", product_code: "M451020318", std_pkg: 1, price_inr_per_pc: 9141.00 },
                { size_mm: "315", length_socket: "6M S/S", product_code: "M451020618", std_pkg: 1, price_inr_per_pc: 18018.00 }
            ]
        },
        {
            name: "RINGFIT PIPES - SN 4",
            fitting_type: "RINGFIT",
            stiffness_class: "SN 4",
            items: [
                { size_mm: "160", length_socket: "3M S/S", product_code: "M451040312", std_pkg: 1, price_inr_per_pc: 3114.00 },
                { size_mm: "160", length_socket: "6M S/S", product_code: "M451040612", std_pkg: 1, price_inr_per_pc: 6138.00 },
                { size_mm: "200", length_socket: "3M S/S", product_code: "M451040314", std_pkg: 1, price_inr_per_pc: 4605.00 },
                { size_mm: "200", length_socket: "6M S/S", product_code: "M451040614", std_pkg: 1, price_inr_per_pc: 9078.00 },
                { size_mm: "250", length_socket: "3M S/S", product_code: "M451040316", std_pkg: 1, price_inr_per_pc: 7278.00 },
                { size_mm: "250", length_socket: "6M S/S", product_code: "M451040616", std_pkg: 1, price_inr_per_pc: 14346.00 },
                { size_mm: "315", length_socket: "3M S/S", product_code: "M451040318", std_pkg: 1, price_inr_per_pc: 11103.00 },
                { size_mm: "315", length_socket: "6M S/S", product_code: "M451040618", std_pkg: 1, price_inr_per_pc: 21876.00 }
            ]
        },
        {
            name: "RINGFIT PIPES - SN 8",
            fitting_type: "RINGFIT",
            stiffness_class: "SN 8",
            items: [
                { size_mm: "110", length_socket: "3M S/S", product_code: "M451080309", std_pkg: 1, price_inr_per_pc: 1689.00 },
                { size_mm: "110", length_socket: "6M S/S", product_code: "M451080609", std_pkg: 1, price_inr_per_pc: 3330.00 },
                { size_mm: "160", length_socket: "3M S/S", product_code: "M451080312", std_pkg: 1, price_inr_per_pc: 3528.00 },
                { size_mm: "160", length_socket: "6M S/S", product_code: "M451080612", std_pkg: 1, price_inr_per_pc: 6954.00 },
                { size_mm: "200", length_socket: "3M S/S", product_code: "M451080314", std_pkg: 1, price_inr_per_pc: 5496.00 },
                { size_mm: "200", length_socket: "6M S/S", product_code: "M451080614", std_pkg: 1, price_inr_per_pc: 10830.00 },
                { size_mm: "250", length_socket: "3M S/S", product_code: "M451080316", std_pkg: 1, price_inr_per_pc: 8421.00 },
                { size_mm: "250", length_socket: "6M S/S", product_code: "M451080616", std_pkg: 1, price_inr_per_pc: 16596.00 },
                { size_mm: "315", length_socket: "3M S/S", product_code: "M451080318", std_pkg: 1, price_inr_per_pc: 13515.00 },
                { size_mm: "315", length_socket: "6M S/S", product_code: "M451080618", std_pkg: 1, price_inr_per_pc: 26634.00 }
            ]
        }
    ]
};

// Helper functions
export const formatPrice = (price) => {
    return new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: 'INR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(price);
};

export const getAllUndergroundProducts = () => {
    const allProducts = [];
    undergroundCatalog.sections.forEach((section, sectionIndex) => {
        section.items.forEach((item, itemIndex) => {
            allProducts.push({
                id: `underground-${sectionIndex}-${itemIndex}`,
                ...item,
                sectionName: section.name,
                fittingType: section.fitting_type,
                stiffnessClass: section.stiffness_class,
                hsnCode: undergroundCatalog.hsn_code
            });
        });
    });
    return allProducts;
};

export const getUndergroundSizes = () => {
    const allProducts = getAllUndergroundProducts();
    return [...new Set(allProducts.map(p => p.size_mm))].sort((a, b) => parseInt(a) - parseInt(b));
};

export const getUndergroundFittingTypes = () => {
    return [...new Set(undergroundCatalog.sections.map(s => s.fitting_type))];
};

export const getUndergroundStiffnessClasses = () => {
    return [...new Set(undergroundCatalog.sections.map(s => s.stiffness_class))];
};
